import { render, staticRenderFns } from "./review.vue?vue&type=template&id=62fe83d6&scoped=true&"
import script from "./review.vue?vue&type=script&lang=js&"
export * from "./review.vue?vue&type=script&lang=js&"
import style0 from "./review.vue?vue&type=style&index=0&id=62fe83d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fe83d6",
  null
  
)

export default component.exports